import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';
import { ReportRecipientParticipant } from '../models';


type AddFilterParticipantAction = {
  type:        ActionType.AddFilterParticipant;
  participant: ReportRecipientParticipant;
}


/**
 * Dispatch this action to add a filter participant.
 * @param participant - the participant to add
 */
export const addFilterParticipantAction = (participant: ReportRecipientParticipant): AddFilterParticipantAction => ({
  type:        ActionType.AddFilterParticipant,
  participant: participant,
});


export const addFilterParticipantReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.AddFilterParticipant) {
    return state;
  }
  
  const action = incomingAction as AddFilterParticipantAction;

  return R.assocPath(
    ['reportRecipientSelectedParticipants', `${action.participant.displayName}`],
    action.participant,
    state,
  );
};
